export default {
  btnAdd:'اضافه کردن دسته بندی',
  btnEdit:'ویرایش',
  placeholderTitle:'نام دسته بندی',
  back : 'لغو',
  save : 'ثبت'



}
